<template>
  <asc-dialog
    text="Parameter Definition"
    :show-dialog="showDialog"
    :on-close="handleClose"
    :width="1000"
  >
    <template v-if="showDialog">
      <asc-parameter-definition
        :definition="definition"
        :loading="loading"
      ></asc-parameter-definition>
    </template>
  </asc-dialog>
</template>

<script>
import { AscDataDefinitionMixin, AscDialogMixin } from '@/components/mixins'
import AscDialog from '@/components/atoms/AscDialog'
import AscParameterDefinition from './AscParameterDefinition'

export default {
  name: 'AscParameterDefinitionDialog',

  components: {
    AscDialog,
    AscParameterDefinition,
  },

  mixins: [AscDataDefinitionMixin, AscDialogMixin],
}
</script>

<style lang="scss" scoped>
.asc-dialog--container {
  display: flex;
  padding: 0;
  margin: 0;
}
</style>
